/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter, PrimeTextInput } from 'components/InputsMex/inputs';
import { URLS_PHP_8 } from 'constants/urls_v2';
import useBuscarColonias from 'hooks/useBuscarColonias';
import useBuscarEstadosByCodigoPostal from 'hooks/useBuscarEstadosByCodigoPostal';
import useBuscarMunicipios from 'hooks/useBuscarMunicipios';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { useLocation } from 'react-router';

const API = ApiKeyFetch.instance();

const UbicacionInput = ({ configuracion, config }) => {
  const [useCodPostalAlways, setUseCodPostalAlways] = useState(false);
  const { buscarEstadosByCodigoPostal } = useBuscarEstadosByCodigoPostal();
  const [estados, setEstados] = useState(configuracion?.estado?.options);
  const [isMounting, setIsMounting] = useState(true);
  const location = useLocation(); // Obtiene la ubicación actual
  const searchParams = new URLSearchParams(location.search); // Analiza la query string
  const [idPoliza, setIdPoliza] = useState(searchParams.get('idPoliza'));
  useEffect(() => {
    setUseCodPostalAlways(config?.useCodPostalAlways || false);
  }, []);

  useEffect(() => {
    init();
  }, [useCodPostalAlways]);

  const init = async () => {
    setIsMounting(true);
    const codPostal = getCodPostal();
    if (config?.useCodPostalAlways && typeof codPostal === 'string') {
      const [estados] = await Promise.all([buscarEstadosByCodigoPostal(codPostal), buscarPorCodigoPostal(codPostal)]);
      setEstados(estados);
    }
    setIsMounting(false);
  };

  const methods = useFormContext();
  const [loadingCodigoPostal, setLoadingCodigoPostal] = useState(false);
  const { addWarningToast } = useCustomToast();
  const nameCodigoPostal = configuracion?.codigoPostal?.name || 'codigoPostal';
  const nameEstado = configuracion?.estado?.name || 'estado';
  const nameMunicipio = configuracion?.municipio?.name || 'municipio';
  const nameColonia = configuracion?.colonia?.name || 'colonia';

  const { codProducto } = useQueryParams();

  const estadoValue = methods.watch(nameEstado);
  const municipioValue = methods.watch(nameMunicipio);
  const coloniaValue = methods.watch(nameColonia);

  const [isBusquedaCodigoPostal, setIsBusquedaCodigoPostal] = useState(false);

  const { municipios, buscarMunicipios, setMunicipios } = useBuscarMunicipios();
  const { buscarColonias, colonias, setColonias } = useBuscarColonias();

  const getCodPostal = () => {
    if (useCodPostalAlways === false) {
      return null;
    }
    return methods.getValues(nameCodigoPostal);
  };

  const onChangeEstado = async () => {
    const estadoValue = methods.watch(nameEstado);
    if (!isBusquedaCodigoPostal) {
      setMunicipios([]);
      setColonias([]);
      if (estadoValue?.codPais && estadoValue?.codDpto) {
        setLoadingCodigoPostal(true);
        await buscarMunicipios(estadoValue?.codPais, estadoValue?.codDpto, getCodPostal());
        setLoadingCodigoPostal(false);
      }
    }
  };

  const onChangeMunicipio = async () => {
    const municipioValue = methods.watch(nameMunicipio);
    if (!isBusquedaCodigoPostal) {
      setColonias([]);
      if (municipioValue?.codPais && municipioValue?.codDpto && municipioValue?.codMunicipio) {
        setLoadingCodigoPostal(true);
        const colonias = await buscarColonias(municipioValue, getCodPostal());
        console.log('COLONIAS: ', municipioValue, colonias);
        setLoadingCodigoPostal(false);
      }
    }
  };

  useEffect(() => {
    if (useCodPostalAlways === false && isMounting === false) {
      onChangeEstado();
    }
  }, [estadoValue, useCodPostalAlways, isMounting]);

  useEffect(() => {
    if (useCodPostalAlways === false && isMounting === false) {
      onChangeMunicipio();
    }
  }, [municipioValue, useCodPostalAlways, isMounting]);

  /**
   *
   * @param {string} codigoPostal
   */
  const buscarPorCodigoPostal = async (codigoPostal) => {
    if (codigoPostal.length === 5 && isBusquedaCodigoPostal === false) {
      setIsBusquedaCodigoPostal(true);
      methods.setValue('estado', null);
      methods.setValue('municipio', null);
      methods.setValue('colonia', null);
      setColonias([]);
      setMunicipios([]);
      setLoadingCodigoPostal(true);

      const Data = {
        datosCotizador: {
          prodCodigo: codProducto || PRODUCTOS.APINDIVIDUAL,
          cotPasoCodigo: 'codigoPostal',
          codigoPostal: codigoPostal,
          idPoliza: idPoliza
        },
      };
      const res = await API.post(URLS_PHP_8.emision.datosEmision, Data);

      if (res.transaccion && res?.catalogo?.codPostalRespuesta) {
        const response = res?.catalogo?.codPostalRespuesta;
        if (response?.municipio?.listado) {
          if (response?.estado?.value) {
            methods.clearErrors(nameEstado);
            methods.setValue(nameEstado, response?.estado?.value);
          }
          setMunicipios(response?.municipio?.listado || []);
          if (response.municipio?.value) {
            methods.clearErrors(nameMunicipio);
            methods.setValue(nameMunicipio, response.municipio?.value);
          }
          setColonias(response?.colonia?.listado || []);
          if (response?.colonia?.value) {
            methods.clearErrors(nameColonia);
            methods.setValue(nameColonia, null);
          }
        } else {
          methods.setError(nameCodigoPostal, {
            type: 'custom',
            message: 'No se han encontrado resultados',
          });
        }
      } else {
        methods.setError(nameCodigoPostal, {
          type: 'custom',
          message: 'No se han encontrado resultados',
        });
        addWarningToast('No se han encontrado resultados');
      }
      setLoadingCodigoPostal(false);
      setIsBusquedaCodigoPostal(false);
    }
  };
  return (
    <React.Fragment>
      <div className="col-md-6 col-xl-5 my-2">
        <SimpleContainer
          name={nameCodigoPostal}
          label={configuracion?.codigoPostal?.label || 'Código postal'}
          info={configuracion?.codigoPostal?.info}
        >
          <PrimeTextInput
            {...configuracion?.codigoPostal}
            name={nameCodigoPostal}
            onChangeFn={buscarPorCodigoPostal}
            loading={loadingCodigoPostal}
            keyfilter="int"
            maxLength={5}
          />
        </SimpleContainer>
      </div>

      <div className="col-md-6 col-xl-5 my-2">
        <SimpleContainer
          name={nameEstado}
          label={configuracion?.estado?.label || 'Estado'}
          info={configuracion?.estado?.info}
        >
          <DropDownFilter
            {...configuracion?.estado}
            options={estados}
            name={nameEstado}
            loading={loadingCodigoPostal}
            onChangeFn={() => {
              if (useCodPostalAlways === false) {
                methods.setValue(nameCodigoPostal, '');
              }
              methods.setValue(nameMunicipio, null);
              methods.setValue(nameColonia, null);
              if (useCodPostalAlways) {
                onChangeEstado();
              }
            }}
          />
        </SimpleContainer>
      </div>

      <div className="col-md-6 col-xl-5 my-2">
        <SimpleContainer
          name={nameMunicipio}
          label={configuracion?.municipio?.label || 'Alcaldía/Municipio'}
          helpText={!estadoValue && 'Antes seleccionar un estado'}
          info={configuracion?.municipio?.info}
        >
          <DropDownFilter
            {...configuracion?.municipio}
            name={nameMunicipio}
            loading={loadingCodigoPostal}
            options={municipios}
            onChangeFn={() => {
              if (useCodPostalAlways === false) {
                methods.setValue(nameCodigoPostal, '');
              }
              methods.setValue(nameColonia, null);
              if (useCodPostalAlways) {
                onChangeMunicipio();
              }
            }}
          />
        </SimpleContainer>
      </div>

      <div className="col-md-6 col-xl-5 my-2">
        <SimpleContainer
          name={nameColonia}
          label={configuracion?.colonia?.label || 'Colonia'}
          helpText={!municipioValue && 'Antes seleccionar un municipio'}
          info={configuracion?.colonia?.info}
        >
          <DropDownFilter
            {...configuracion?.colonia}
            name={nameColonia}
            loading={loadingCodigoPostal}
            options={colonias}
            onChangeFn={(colonia) => {
              if (!isBusquedaCodigoPostal) {
                if (useCodPostalAlways === false) {
                  methods.setValue(nameCodigoPostal, colonia?.codPostal);
                }
                methods.clearErrors(nameCodigoPostal);
              }
            }}
          />
        </SimpleContainer>
      </div>
    </React.Fragment>
  );
};

export default UbicacionInput;
